import { NgModule } from '@angular/core';
import { ChartjsComponent } from './chartjs.component';

@NgModule({
  imports: [
    ChartjsComponent
  ],
  exports: [
    ChartjsComponent
  ]
})
export class ChartjsModule { }
